export const locale = {
    lang: 'nl',
    data: {
        'TECHNOLOGIES': {
            'TECHNOLOGIES': 'Technologieën'
        }
    }
};
